import Draggable from 'react-draggable';
import React from 'react';
import { Row, Col } from 'reactstrap';

import 'style/configurator/Modal.css';

const DraggableModal = ({
  children,
  closeModalNotSaved,
  wallCoordinates,
}: {
  children: JSX.Element[];
  closeModalNotSaved: () => void;
  wallCoordinates?: any;
}): JSX.Element => (
  <Draggable cancel=".text-field">
    <div className="properties-edit-popup">
      <Row>
        <Col>
          <h2
            onClick={() =>
              closeModalNotSaved !== undefined ? closeModalNotSaved() : null
            }
          >
            &times;
          </h2>
        </Col>
      </Row>
      {children}
    </div>
  </Draggable>
);

export default DraggableModal;
